import { Country, Currency } from '@backmarket/http-api'

/**
 * Extended currency enum that includes additional currencies beyond the base Currency enum
 * Based on KYB specs requirements
 */
export enum ExtendedCurrency {
  // Existing currencies from @backmarket/http-api
  AUD = Currency.AUD,
  EUR = Currency.EUR,
  GBP = Currency.GBP,
  JPY = Currency.JPY,
  SEK = Currency.SEK,
  USD = Currency.USD,

  // Additional North American currencies
  // Canadian dollar
  CAD = 'CAD',

  // Additional European currencies
  // Danish krone
  DKK = 'DKK',
  // Hungarian forint
  HUF = 'HUF',
  // Polish złoty
  PLN = 'PLN',
  // Romanian leu
  RON = 'RON',
  // Bulgarian lev
  BGN = 'BGN',
  // Czech koruna
  CZK = 'CZK',
}

/**
 * Form values type for BusinessDetails component
 * Using flattened structure for proper form validation integration
 */
export type BusinessFormValues = {
  legalName: string
  tradeName: string
  kanaLegalName: string
  latinLegalName: string
  email: string
  countryOfRegistration: string
  registrationType: string
  registrationNumber: string
  incorporationDate: string
  secondhandDealerNumber: string
  secondhandDealerNumberIssuingPrefecture: string
  proofOfSecondHandDealerLicence: File[]
  headquartersStreet: string
  headquartersStreet2: string
  headquartersCity: string
  headquartersPostalCode: string
  headquartersCountry: Country | ''
  registeredBusinessStreet: string
  registeredBusinessStreet2: string
  registeredBusinessCity: string
  registeredBusinessPostalCode: string
  registeredBusinessCountry: Country | ''
  branchesAddresses: BranchAddress[]
  w9: File[]
  articleOfIncorporation: File[]
  investedCapitalCurrency: string
  investedCapitalAmount: number
}

/**
 * Branch address type for dynamic branch address handling
 * Kept as object since branches are added/removed dynamically
 */
export type BranchAddress = {
  street: string
  street2?: string
  city: string
  postalCode: string
  country: Country | ''
}
